export const routes = {
  home: '/',
  addPost: '/addPost',
  auth: '/auth',
  search: '/search',
};
